
import { Link } from 'react-router-dom';
import { mockProducts } from '../../../mocks/products';

interface CompareBarProps {
  selectedIds: string[];
  onRemove: (id: string) => void;
  onClear: () => void;
}

export default function CompareBar({ selectedIds, onRemove, onClear }: CompareBarProps) {
  if (selectedIds.length === 0) return null;

  const selectedProducts = selectedIds
    .map((id) => mockProducts.find((p) => p.id === id))
    .filter(Boolean);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-carbon-900 border-t border-neon/20 shadow-[0_-8px_30px_rgba(0,255,136,0.08)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-6">
          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-scales-3-line text-neon text-base"></i>
            </div>
            <span className="text-white text-sm font-bold whitespace-nowrap">
              Compare ({selectedIds.length}/4)
            </span>
          </div>

          <div className="flex items-center gap-3 flex-1 overflow-x-auto scrollbar-hide">
            {selectedProducts.map((product) =>
              product ? (
                <div
                  key={product.id}
                  className="flex items-center gap-2 bg-white/5 border border-white/10 px-3 py-2 flex-shrink-0"
                >
                  <div className="w-8 h-8 overflow-hidden flex-shrink-0">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <span className="text-white text-xs font-medium whitespace-nowrap max-w-[120px] truncate">
                    {product.name}
                  </span>
                  <button
                    onClick={() => onRemove(product.id)}
                    className="w-5 h-5 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-close-line text-sm"></i>
                  </button>
                </div>
              ) : null
            )}

            {selectedIds.length < 4 && (
              <div className="flex items-center gap-1 px-3 py-2 border border-dashed border-white/10 flex-shrink-0">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-add-line text-white/20 text-sm"></i>
                </div>
                <span className="text-white/20 text-xs whitespace-nowrap">Add product</span>
              </div>
            )}
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={onClear}
              className="px-4 py-2 text-white/40 hover:text-white text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Clear All
            </button>
            {selectedIds.length >= 2 ? (
              <Link
                to={`/products/compare?ids=${selectedIds.join(',')}`}
                className="px-6 py-2.5 bg-neon text-black text-xs font-bold hover:bg-neon/90 transition-colors cursor-pointer whitespace-nowrap"
              >
                Compare Now
              </Link>
            ) : (
              <span className="px-6 py-2.5 bg-white/5 text-white/30 text-xs font-bold whitespace-nowrap">
                Select at least 2
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
